import { EmailVerifiedComponentProps } from '../components/CommonEmailVerified'

export interface EmailVerifiedComponents {
    AlreadyVerified: (props: EmailVerifiedComponentProps) => JSX.Element
    Verified: (props: EmailVerifiedComponentProps) => JSX.Element
    Invalid: (props: EmailVerifiedComponentProps) => JSX.Element
}

export const consumeQueryParamsAndReturn = (
    queryParams: URLSearchParams,
    components: EmailVerifiedComponents,
) => {
    const { AlreadyVerified, Verified, Invalid } = components

    const successful = queryParams.get('success')
    const code = queryParams.get('code')

    return queryParams.has('success') && successful === 'false' // Query parameters equal to the already verified state
        ? AlreadyVerified
        : code === 'success' && successful === 'true' // Query parameters equal successful verification
        ? Verified
        : Invalid // Otherwise, it's an invalid state component
}
